import React from 'react'
import { ActionButton } from '@emerald-works-nova/components'
import { Box, Chip, Dialog, DialogTitle, Divider, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material'
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { useStyles } from './style'

export function MoveSubCategoryModal ({
  category,
  parentCategory,
  hierarchy,
  handleMove,
  handleSubCategorySelection,
  newParentCategorySk,
  setNewParentCategorySk,
  open,
  onCancel
}) {
  const [step, setStep] = React.useState(0)
  const [selectedGroupCategory, setSelectedGroupCategory] = React.useState(null)
  const classes = useStyles()

  const handleSelection = groupCategory => {
    const children = groupCategory.children ? groupCategory.children.filter(({ sk }) => sk !== parentCategory.sk) : []
    setSelectedGroupCategory({ ...groupCategory, children })
    setStep(1)
  }

  React.useEffect(() => {
    setStep(0)
    setNewParentCategorySk(null)
  }, [open, setNewParentCategorySk])

  const renderStep = () => {
    switch (step) {
      case 0:
        return (
          <>
            <DialogTitle id='select-subcategory-step-0' className={classes.dialogTitle}>
              <Grid container className={classes.modalHeader}>
                <Typography variant='h5' data-test='subcategory-to-move-step-0'>Move {`"${category.name}"`}</Typography>
                <Typography variant='subtitle1'><b>Group Categories</b></Typography>
              </Grid>
            </DialogTitle>
            <Typography variant='subtitle1'>Select the group category</Typography>
            <Box
              display='flex'
              flexDirection='column'
              mb={2}
              height='250px'
              className={classes.categoriesBox}
            >
              {hierarchy.map(item =>
                <Box key={item.sk} onClick={() => { handleSelection(item) }} className={classes.subcategoryItem} data-test='group-category-selection'>
                  <div className={classes.rootCategory}>
                    <Typography key={item.sk}>{item.name}</Typography>
                    {!item.isVisible && <Chip size='small' icon={<DoNotDisturbAltIcon />} label='Disabled' className={classes.disabledIcon} />}
                  </div>
                  <ArrowForwardIcon />
                </Box>
              )}
            </Box>
            <div className={classes.buttonsContainer}>
              <ActionButton
                variant='secondary'
                onClick={onCancel}
                className={classes.actionButton}
              > Cancel
              </ActionButton>
            </div>
          </>
        )
      case 1:
        return (
          <>
            <DialogTitle id='select-subcategory-step-1' className={classes.dialogTitle}>
              <Grid container className={classes.modalHeader}>
                <Typography variant='h5' data-test='subcategory-to-move-step-1'>Move {`"${category.name}"`}</Typography>
                <Typography variant='h6' className={classes.arrowHeader} data-test='group-category-selected'>
                  <ArrowBackIcon onClick={() => setStep(0)} className={classes.arrowHeaderIcon} />
                  {selectedGroupCategory?.name}
                </Typography>
              </Grid>
            </DialogTitle>
            <Typography variant='subtitle1'>Select the category to move to</Typography>
            <Box
              display='flex'
              flexDirection='column'
              mb={2}
              height='250px'
              className={classes.categoriesBox}
            >
              <RadioGroup
                value={newParentCategorySk}
                onChange={(e) => handleSubCategorySelection(selectedGroupCategory, e.target.value)}
                data-test='category-selection'
              >
                {(!selectedGroupCategory.children || selectedGroupCategory.children.length === 0) && (
                  <Typography variant='subtitle1' color='red' data-test='category-error-msg'>This group category does not have any categories available to select.</Typography>
                )}
                {selectedGroupCategory.children.map(({ sk, name, isVisible }) =>
                  isVisible
                    ? <FormControlLabel key={sk} value={sk} control={<Radio />} label={name} />
                    : (
                      <Box key={sk} className={classes.disabledItem}>
                        <FormControlLabel value={sk} control={<Radio />} label={name} />
                        <Chip size='small' icon={<DoNotDisturbAltIcon />} label='Disabled' className={classes.disabledIcon} />
                      </Box>
                    )
                )}
              </RadioGroup>
            </Box>
            <Divider />
            <div className={classes.arrowFooter}>
              <Typography variant='subtitle1' color='gray'>Group Categories</Typography>
              <ArrowForwardIosIcon className={classes.arrowFooterIcon} />
              <Typography variant='subtitle1'>{selectedGroupCategory?.name}</Typography>
            </div>
            <div className={classes.buttonsContainer}>
              <ActionButton
                variant='secondary'
                onClick={onCancel}
                className={classes.actionButton}
              >
                {' '}
                Cancel
              </ActionButton>
              <ActionButton
                variant='primary'
                onClick={handleMove}
                className={classes.actionButton}
                disabled={!newParentCategorySk}
              >
                Move
              </ActionButton>
            </div>
          </>
        )
    }
  }

  return (
    <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
      {renderStep()}
    </Dialog>)
}
